import { QuerySend } from "@/shared/models/FormQuerySend";
import axios from "axios";
import { Response } from "../../../shared/models/Response";
import { ServiceTemplateHeader } from "../models/ServiceTemplateHeader";
import { ServiceTemplateModel } from "../models/ServiceTemplateModel";
import { ServiceTemplateMultiFilters } from "../models/ServiceTemplateMultiFilters.model";
import { ServiceTemplatePagination } from "../models/ServiceTemplatePagination";
import { ServiceTemplatesGraphResponse } from "../models/ServiceTemplatesGraphResponse.model";
import { SessionTemplatePagination } from "../models/SessionTemplatePagination";
import { ServiceTemplateByAvailability } from "../models/ServiceTemplateByAvailability.model";

export class ServiceTemplateService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/service-templates`;
  }

  async getServiceTemplateWithFilters(
    query: QuerySend
  ): Promise<Response<ServiceTemplatePagination>> {
    const res = await axios.get(`${this.baseUrl}/find-by-filters`, {
      params: query
    });
    return res.data;
  }

  async getServiceTemplateById(
    id: string
  ): Promise<Response<ServiceTemplateModel>> {
    const serviceURL = `${this.baseUrl}/${id}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async getServiceTemplateByIdBasicInfo(
    id: string
  ): Promise<Response<ServiceTemplateModel>> {
    const serviceURL = `${this.baseUrl}/basic-info/${id}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async verifymultipleInstances(
    id: string
  ): Promise<Response<ServiceTemplateModel>> {
    const serviceURL = `${this.baseUrl}/verify-multipleInstances/${id}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async getSessionsByFilters(
    query: QuerySend
  ): Promise<Response<SessionTemplatePagination>> {
    const serviceURL = `${process.env.VUE_APP_FORMS_API}/session-templates/find-by-filters`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async addServiceTemplate(
    serviceTemplate: ServiceTemplateModel
  ): Promise<Response<string | void>> {
    const serviceURL = `${this.baseUrl}/add-service`;
    const response = await axios.post(serviceURL, serviceTemplate);
    return response.data;
  }

  async updateServiceTemplate(
    id: string,
    serviceTemplate: ServiceTemplateModel
  ): Promise<Response<string | void>> {
    const serviceURL = `${this.baseUrl}/${id}`;
    const response = await axios.put(serviceURL, serviceTemplate);
    return response.data;
  }

  async checkIfExistByName(name: string): Promise<Response<string | void>> {
    const serviceURL = `${this.baseUrl}/exist-by-name`;
    const response = await axios.get(serviceURL, { params: { name: name } });
    return response.data;
  }

  async deleteServiceTemp(id: string): Promise<Response<string | void>> {
    return (await axios.delete(`${this.baseUrl}/${id}`)).data;
  }

  async getAllServiceTemplatesByAvailability(
    id: string
  ): Promise<Response<ServiceTemplateByAvailability[] | void>> {
    const serviceUrl = `${this.baseUrl}/find-service-temp-by-availability-temp/${id}`;
    const response = await axios.get(serviceUrl);
    return response.data;
  }

  async getAllActiveServiceTemplate(
    state?: string
  ): Promise<Response<ServiceTemplateHeader[]>> {
    const res = await axios.get(
      `${this.baseUrl}/get-all-active-service-templates`,
      {
        params: {
          state
        }
      }
    );

    return res.data;
  }

  async updateStateServiceTemplateById(
    id: string,
    state: string
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/state/${id}/${state}`;
    const response = await axios.put(serviceUrl);
    return response.data;
  }

  async getDataChart(
    filters: ServiceTemplateMultiFilters
  ): Promise<Response<ServiceTemplatesGraphResponse>> {
    const serviceUrl = `${this.baseUrl}/charts`;
    const response = await axios.get(serviceUrl, {
      params: filters
    });
    return response.data;
  }
}
